import { render, staticRenderFns } from "./UserDev.vue?vue&type=template&id=1ec3f596&scoped=true&"
import script from "./UserDev.vue?vue&type=script&lang=js&"
export * from "./UserDev.vue?vue&type=script&lang=js&"
import style0 from "./UserDev.vue?vue&type=style&index=0&id=1ec3f596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3f596",
  null
  
)

export default component.exports